// Per-user preference for the mobile bottom-nav auto-hide drawer.
// Stored in localStorage; a window event keeps AppShell in sync when
// the toggle lives on a different page (Profile).

const EVENT = 'nav-autohide-changed'
const key = userId => `navAutoHide:${userId || 'anon'}`

export function getNavAutoHide(userId) {
  return localStorage.getItem(key(userId)) === '1'
}

export function setNavAutoHide(userId, value) {
  localStorage.setItem(key(userId), value ? '1' : '0')
  window.dispatchEvent(new CustomEvent(EVENT, { detail: value }))
}

export function onNavAutoHideChange(handler) {
  const listener = e => handler(e.detail)
  window.addEventListener(EVENT, listener)
  return () => window.removeEventListener(EVENT, listener)
}
